import { Component, HostListener, output, ChangeDetectionStrategy } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-pull-to-refresh',
  standalone: true,
  imports:[MatProgressSpinnerModule],
  template: `
    <div class="refresh-container">
      @if(isRefreshing){
      <div class="refresh-spinner">
        <mat-spinner diameter="30"></mat-spinner>
      </div>
      }
      <ng-content></ng-content>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [`
    .refresh-container {
      position: relative;
      overflow: hidden;
    }
    .refresh-spinner {
      display: flex;
      justify-content: center;
      padding: 10px;
    }
  `]
})
export class PullToRefreshComponent {
  readonly refresh = output<void>();
  isRefreshing = false;
  private startY = 0;

  @HostListener('touchstart', ['$event'])
  onTouchStart(event: TouchEvent) {
    this.startY = event.touches[0].pageY;
  }

  @HostListener('touchmove', ['$event'])
  onTouchMove(event: TouchEvent) {
    const currentY = event.touches[0].pageY;
    const deltaY = currentY - this.startY;

    if (deltaY > 50 && !this.isRefreshing) {
      this.isRefreshing = true;
      this.refresh.emit();
    }
  }

  @HostListener('touchend')
  onTouchEnd() {
    this.isRefreshing = false;
  }
}
